import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { BrowserRouter } from "react-router-dom"
import App from "./App"
import { PreviewProvider } from "./content/PreviewProvider"
import "./styles.css"

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <PreviewProvider>
        <App />
      </PreviewProvider>
    </BrowserRouter>
  </StrictMode>,
)
